import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="bg-cream pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-74">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex-1 text-center lg:text-left z-10" data-id="element-76">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest font-bold leading-tight mb-6" data-id="element-77">
            Desinflama tu cuerpo en 72 horas y vuelve a sentirte ligera, cómoda
            y segura en tu ropa
          </h1>
          <h2 className="text-xl md:text-2xl text-forest-light font-medium mb-8" data-id="element-78">
            Una guía digital en español, creada para mujeres latinas en USA, con
            pasos simples para reducir la hinchazón, sentir menos pesadez y
            empezar un reset práctico desde casa.
          </h2>
          <ul className="text-left text-lg text-gray-700 space-y-3 mb-10" data-id="element-79">
            <li className="flex items-start gap-3" data-id="element-80">
              <span className="text-green-500 text-xl leading-tight" data-id="element-81">✅</span>
              <span data-id="element-82">Qué comer durante 3 días para sentirte más ligera</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-83">
              <span className="text-green-500 text-xl leading-tight" data-id="element-84">✅</span>
              <span data-id="element-85">Lista práctica de compras en supermercados de USA</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-86">
              <span className="text-green-500 text-xl leading-tight" data-id="element-87">✅</span>
              <span data-id="element-88">
                Rutina simple de apoyo para reducir pesadez e inflamación
              </span>
            </li>
          </ul>
          <div className="flex flex-col items-center lg:items-start" data-id="element-89">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => document.getElementById('offer-price')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} className="inline-block bg-gold hover:bg-gold-hover text-forest font-bold py-4 px-8 rounded-full shadow-lg transition-colors text-lg md:text-xl w-full md:w-auto text-center cursor-pointer" data-id="element-90">
              SÍ, QUIERO MI GUÍA AHORA
            </motion.button>
            <p className="text-sm text-gray-500 mt-4 font-medium" data-id="element-91">
              Acceso inmediato · Producto digital en PDF · Pago único
            </p>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-92">
          <div className="absolute inset-0 bg-sage rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-93"></div>
          <img src="https://cdn.magicpatterns.com/uploads/u3h6xU6zEcqbpUAvD2WZDQ/Mockup_PTO_1_Anti-Desinflamacion_72H.png" alt="Protocolo Anti-Inflamación 72h" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl rounded-2xl" data-id="element-94" />
        </motion.div>
      </div>
    </section>;
}